import React from 'react';
import { getServiceCandidateRequestBidsCount } from '../../services/Seller';
import bgImg from '../../assets/images/newui/no-subs-bg.svg'
import next from '../../assets/images/newui/sellersignup/next-btn.svg'

import './NoSubscriptionContainer.less';

class NoSubscriptionContainer extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            biddableRequestCount: 0,
            categoryName: '',
        }
    }

    componentDidMount() {
        this._isMounted = true;
        getServiceCandidateRequestBidsCount()?.then(({ data }) => {
            const service = data.count.length ? this.getObjectWithMaxCount(data.count) : [];
            if (this._isMounted) {   
                this.setState({
                    biddableRequestCount: service.count,
                    categoryName: service.categoryName
                })
            }
        })
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getObjectWithMaxCount = (rows) => rows.reduce((prev, current) => {
        return (prev.count > current.count) ? prev : current
    })

    render() {
        return <div className='no-subscription-container'>
            <div className='no-subscription-header'>
                {/* You have {this.state.biddableRequestCount || ''} Active Customer(s) */}
                Start getting qualified leads today
            </div>
            {/* <div className='no-subscription-sub-header'>
                Start getting qualified leads today
            </div> */}
            <div className='no-subscription-img'>
                <img src={bgImg} />
            </div>
            <div className='no-subscription-link'>
                <a href='/add-subscription'>SIGNUP <img src={next} /></a>
            </div>
            <div className='no-subscription-text'>for a subscription {this.state.categoryName ? ` to "${this.state.categoryName}"` : ''} now to access these customers and more.</div>

        </div>

    }
}


export default NoSubscriptionContainer;